/* Orders */

	const TYPE_SERVICES = 0x1;
	const CUSTOM_PICKUP = 0x2;
    const MASK_SERVICE_TYPE = 0x7;

    const HAS_DELIVERY = 0x08;

    const WAITING_CLIENT = 0x10;
    const WAITING_ADMIN = 0x20;
    const WAITING_PROVIDER = 0x40;
    const MASK_WAITING = 0x070;

	const PENDING = 0x080;

	const UNCONFIRMED = 0x100;

	const WAITING_PAYMENT = 0x200;
	const ACCEPTED = 0x400;
    const ASSIGNED = 0x800;
	const RUNNING =  0x1000;
	const TARGET_REACHED = 0x2000;
	const FLAG_WORKING = 0x4000;
	const TYPE_CUSTOM = 0x0010;

	const COMPLETED = 0x08000;
	//const TARGET_REACHED = 8192;
	const CANCELLED = 0x18000;

	
	const POST_PAYMENT = 0x100000;

	const BEING_PREPARED = 0x0200000;//new
	const PREPARED = 0x0400000;//new

 	const READY_TO_COLLECT = 0x800000;
 	const COLLECTED = 0x1000000;
 	const EXPIRED = 0x2000000;

	const ACCEPTED_PENDING = 1152;
	const ACCEPTED_SCHEDULED = 1024;
	const ASSIGNED_PENDING = 2176;
	const ASSIGNED_SCHEDULED = 2048;
	const QUEUED_PENDING = 640;
	const QUEUED_SCHEDULED = 512;
	const UNCONFIRMED_PENDING = 384;
	const UNCONFIRMED_SCHEDULED = 25;



	

	//const WAITING_PAYMENT = 512/*16*/;
	




/* ACCOUNT */

	const ADMIN_HIGH = 119;
	const ADMIN_LOW = 112;
	const ADMIN_OWNER = 127;
	const CLIENT = 0;
	const PROVIDER = 15;
	const SUPER_ADMIN = 255;


/* GOODS */

	const GOODS_TYPE_FLAG = 0;
	const SERVICE_TYPE_FLAG = 1;



/* PROPERTIES */

	const PROPERTY_OPTION_SUBMASK = 4095;

	const PROPERTY_TYPE_OPTIONS = 256;
	const PROPERTY_TYPE_RANGE = 512;
	const PROPERTY_TYPE_TEXT = 1024;

/* PAYMENT */

	const VALUE_STATUS_CANCELLED_BY_CLIENT = 10;
	const MASK_STATUS = 15;
	const VALUE_TYPE_PAYPAL = 32;
	const VALUE_TYPE_STRIPE = 64;
	const VALUE_TYPE_INSTAPAGO = 128;
	const VALUE_TYPE_ZELLE = 0x0100;
	const VALUE_TYPE_MANUAL = 0x010;
	const VALUE_TYPE_EFECTIVO = 0x200;
	const MASK_AGENT = 65520;
	const PAYMENT_REGISTERED = 0x100400;  // el pago ya sea por efectivo o no, fue validado por los admins de dondemand
	const VALUE_TYPE_BDV = 0x1000;
	const VALUE_TYPE_BALANCE = 0x0800;//digase saldo

/* PROVIDERS */

	const IS_SERVICE_PROVIDER = 256;
	const IS_GOOD_DELIVERER = 512;
	const IS_DIGITAL = 4;


export {
	IS_DIGITAL,
	VALUE_TYPE_BALANCE,
	VALUE_TYPE_BDV,
	TYPE_SERVICES,
	CUSTOM_PICKUP,
	PAYMENT_REGISTERED,
	MASK_SERVICE_TYPE,
	HAS_DELIVERY,
	WAITING_CLIENT,
	WAITING_ADMIN,
	WAITING_PROVIDER,
	MASK_WAITING,
	UNCONFIRMED,
	WAITING_PAYMENT,
	ACCEPTED,
	ASSIGNED,
	RUNNING,
	TARGET_REACHED,
	FLAG_WORKING,
	COMPLETED,
	CANCELLED,
	POST_PAYMENT,
	BEING_PREPARED,
	PREPARED,
	READY_TO_COLLECT,
	COLLECTED,
	EXPIRED,
	PENDING,
	ACCEPTED_PENDING,
	ACCEPTED_SCHEDULED,
	ASSIGNED_PENDING,
	ASSIGNED_SCHEDULED,
	QUEUED_PENDING,
	QUEUED_SCHEDULED,
	UNCONFIRMED_PENDING,
	UNCONFIRMED_SCHEDULED,
	ADMIN_HIGH,
	ADMIN_LOW,
	ADMIN_OWNER,
	CLIENT,
	PROVIDER,
	SUPER_ADMIN,
	GOODS_TYPE_FLAG,
	SERVICE_TYPE_FLAG,
	PROPERTY_OPTION_SUBMASK,
	PROPERTY_TYPE_OPTIONS,
	PROPERTY_TYPE_RANGE,
	PROPERTY_TYPE_TEXT,
	VALUE_STATUS_CANCELLED_BY_CLIENT,
	MASK_STATUS,
	VALUE_TYPE_PAYPAL,
	VALUE_TYPE_STRIPE,
	VALUE_TYPE_INSTAPAGO,
	MASK_AGENT,
	IS_SERVICE_PROVIDER,
	IS_GOOD_DELIVERER,
	VALUE_TYPE_ZELLE,
	VALUE_TYPE_EFECTIVO,
	VALUE_TYPE_MANUAL,
	TYPE_CUSTOM
}


// WEBPACK FOOTER //
// ./src/constants/bitwiseOperations.js